import { Add } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { Customer } from "../../data/models/customers/CustomerModel";
import { useCustomers } from "../hooks/useCustomers";
import CreateEditCustomerDialog from "./components/CreateEditCustomerDialog";
import CustomersTable from "./components/CustomersTable";

export default function CustomersPage() {
  const { customers, createCustomer, updateCustomer, deleteCustomer, loading } =
    useCustomers();

  const [openCustomer, setOpenCustomer] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState<Customer | null>(null);

  const handleCreateCustomer = () => {
    setEditingCustomer(null);
    setOpenCustomer(true);
  };

  const handleEditCustomer = (customer: Customer) => {
    setEditingCustomer(customer);
    setOpenCustomer(true);
  };

  return (
    <Box
      sx={{
        px: { xs: 2, md: 4 },
        py: { xs: 3, md: 4 },
        width: "100%",
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent={{ xs: "flex-start", md: "space-between" }}
        gap={2}
        mb={3}
      >
        <Typography variant="h5" fontWeight={700}>
          Gestión de clientes
        </Typography>

        <Stack direction="row" gap={1.5} flexWrap="wrap">
          <Button
            variant="contained"
            startIcon={<Add />}
            sx={{ borderRadius: 999 }}
            onClick={handleCreateCustomer}
          >
            Nuevo cliente
          </Button>
        </Stack>
      </Stack>

      <CustomersTable
        customers={customers}
        deleteCustomer={deleteCustomer}
        onEdit={handleEditCustomer}
      />

      <CreateEditCustomerDialog
        open={openCustomer}
        onClose={() => setOpenCustomer(false)}
        initialValue={editingCustomer || undefined}
        onSave={async (data) => {
          if (editingCustomer) {
            await updateCustomer(editingCustomer.id!, data);
          } else {
            await createCustomer(data as any);
          }
          setOpenCustomer(false);
        }}
        loading={loading}
      />
    </Box>
  );
}
